import { logout } from 'myredux/loginSlice';
import { setPath } from 'myredux/globalSlice';
import { getStore, getThunkDispatch } from 'myredux/store';
import { createNotification, isUndefined } from 'utils/utils';
import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://nfs-server-2rbgn.ondigitalocean.app/',
    //baseURL: 'http://localhost:9090/'
});

instance.interceptors.request.use(request => {
    const session = getStore().getState()?.login;
    const token = session.token;
    const expirationDate = typeof session?.expirationDate === 'string' ? Date.parse(session?.expirationDate) : session?.expirationDate;
    
    if (expirationDate !== undefined && expirationDate < new Date() && !isUndefined(token)) {
        getThunkDispatch()(logout());
    } else if (!isUndefined(token) && expirationDate !== undefined && expirationDate > new Date()) {
        request.headers.setAuthorization("Bearer " + token);
    }
    return request;
});

instance.interceptors.response.use(
    response => {
        if (response.data.code === 'ERROR') {
            createNotification('ERROR', response.data.message, 'Chyba aplikace');
            getThunkDispatch()(setPath("/secured/500"));
        }
        return response;
    },
    error => {
        const { token } = getStore().getState()?.login;
        if (error.status === 401) {
            createNotification('ERROR', 'Špatné přihlašovací údaje.', 'Chyba uživatele');
            return Promise.reject(error);
        }

        if (token) getThunkDispatch()(logout());
    }
  );

export default instance;